import { RegisterFormFields } from './RegisterForm.types';

export const performRegister = ({
  firstName,
  lastName,
  email,
  password,
  confirmPassword,
  optedInToSembonus,
}: RegisterFormFields) =>
  fetch(`/d/mvc/Members/Signup`, {
    body: JSON.stringify({
      firstName,
      lastName,
      email,
      password,
      confirmPassword,
      optedInToSembonus,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    credentials: 'include',
  });

export const performSubscribeNewsletter = ({
  firstName,
  lastName,
  email,
}: RegisterFormFields) =>
  fetch(`/d/mvc/subscribetonewsletter/subscribe`, {
    body: JSON.stringify({
      firstName,
      lastName,
      email,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    credentials: 'include',
  });
